export default __webpack_public_path__ + "static/media/s_wdt_c_3_4.501c48f5.mp3";